import { render, staticRenderFns } from "./PassengerUpdateForm.vue?vue&type=template&id=0aa4343c"
import script from "./PassengerUpdateForm.vue?vue&type=script&lang=js"
export * from "./PassengerUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports